import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { PlayerService } from './player.service';
import { AppComponent } from './app.component';
import { PlayerComponent } from './player/player.component';
import { MotorbuttonComponent } from './motorbutton/motorbutton.component';
import { SliderComponent } from './slider/slider.component';
import { KnobComponent } from './knob/knob.component';
import { SwitchComponent } from './switch/switch.component';
import { DiscoarmComponent } from './discoarm/discoarm.component';
import { SocketComponent } from './socket/socket.component';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { WindowRef } from './window';
import { LoaderComponent } from './loader/loader.component';

export class MyHammerConfig extends HammerGestureConfig  {
  overrides = <any>{
      'pan': {pointers: 0, threshold: 1} // override default settings
  };
}


@NgModule({
  declarations: [
    AppComponent,
    PlayerComponent,
    MotorbuttonComponent,
    SliderComponent,
    KnobComponent,
    SwitchComponent,
    DiscoarmComponent,
    SocketComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule
  ],
  providers: [PlayerService,[WindowRef, {
    provide: HAMMER_GESTURE_CONFIG,
    useClass: MyHammerConfig
  }]],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts